import { Axios } from 'axios';
import { createProxyHttpClient } from '@guestyci/gfh-utils';
import Resource from '@guestyci/agni';
import config from '../config';
import utils from '../utils';
import constant from '../constant';
import getBaseUserInfo from './handlers/user';
import getUserData from '../utils/user';
import setKongToken from './handlers/setKongToken';

// API instance used for general-purpose requests
const { api } = Resource.create({
  baseURL: config.apiOrigin,
});

// API instance used for requests to the GFH (YPA) back end
const { api: gfhApiInstance } = Resource.create({ baseURL: config.apiOrigin });

(gfhApiInstance as Axios).interceptors.request.use((requestConfig) => {
  const { sessionToken, authenticatedData, uuid } = utils.getLocalStorageByKey(
    'sessionToken',
    'authenticatedData',
    'uuid'
  );
  const userId = authenticatedData?.baseUserInfo?.userId;
  const { name, version } = utils.getBrowserVersion();

  // eslint-disable-next-line no-param-reassign
  requestConfig.headers = {
    'ypa-version': constant.IONIC_APP_VERSION,
    'ypa-device': uuid,
    'ypa-platform': name,
    'ypa-platform-version': version,
    stoken: sessionToken,
    utoken: userId,
    ...requestConfig.headers,
  };

  return requestConfig;
});

export const gfhAPI = gfhApiInstance;

const proxyApiInstance = createProxyHttpClient({ baseURL: config.proxyOrigin });

proxyApiInstance.interceptors.response.use(
  (res) => {
    return res;
  },
  async (err) => {
    const originalConfig = err.config;
    // Access Token was expired
    if (err.response?.status === 401 && !originalConfig._retry) {
      originalConfig._retry = true;

      try {
        const { sessionToken } = getUserData()!;
        const authenticatedData = await getBaseUserInfo();
        if (!authenticatedData.baseUserInfo) return await Promise.reject(err);
        utils.setLocalStorage({ authenticatedData });
        await setKongToken(
          authenticatedData.baseUserInfo?.userId!,
          sessionToken,
          authenticatedData.baseUserInfo?.accountId!
        );

        return await proxyApiInstance(originalConfig);
      } catch (_error) {
        console.log(_error);
        return Promise.reject(_error);
      }
    }

    return Promise.reject(err);
  }
);

export const proxyAPI = proxyApiInstance;

export default api;
